import "./styles.scss"

const ModalHeaderBack = ({ title, handleGoBack, children }) => {
  return (
    <div className="modal-header-back">
      <div className="modal-header-back-button-title">
      <button className="back-button" onClick={handleGoBack}>
        <i className="fi fi-sr-arrow-small-left" />
      </button>
      <div className="title">{title}</div>
      </div>
      {children}
    </div>
  )
}

export default ModalHeaderBack
